import React,{useEffect,useRef} from "react";
import Arrow from "../assets/Arrow.svg"
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


const Bar = ()=>{
    const bar = useRef(null);
    
    useEffect(() => {
        gsap.set(bar.current, { opacity: 0, y: 100 });

        gsap.to(bar.current, {
            opacity: 1,
            y: 0,
            duration: 2,
            scrollTrigger: {
                trigger: bar.current,
                start: "top 100%",
                end: "bottom top",
                toggleActions: "play none none none",
            },
        });
    },[]);


    return(
        <div ref={bar} className="flex">
            <a href="https://wa.link/5tkorz" target="_blank" rel="noopener noreferrer" className="flex items-center w-fit py-[0.6px] md:py-[0.9px] xl:py-[1.5px] px-[1px] md:px-[1.1px] xl:px-[2.1px] pr-1 md:pr-2 rounded-full bg-white border-[1.5px] border-grey shadow-long-drop font-bold">
                <div className="bg-custom-gradient py-1 px-2 md:px-4 xl:px-6 rounded-full w-fit text-white text-9 md:text-10 xl:text-17">Limited Spots!</div>
                <p className="flex font-semiBold text-9 md:text-10 xl:text-17 items-center ml-1 md:ml-2 xl:ml-4 text-red">March Study Abroad Intake<span className="flex items-center ml-2 mr-2"><img src={Arrow} alt="" className="h-4 md:h-4 xl:h-8"/></span></p>
            </a>
        </div>
    )
}

export default Bar;